/**
 * Vue router config to map URLs to view components.
 * @author bmk11u
 */
// import Vue from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import Login from './views/Login.vue'
import Landing from './views/Homepage.vue'
import Timetable from './views/Timetable.vue'
import Menu from './views/Menu.vue'
import BuildingFrom from './views/roomfinder/BuildingFrom.vue'
import BuildingTo from './views/roomfinder/BuildingTo.vue'
import Directions from './views/roomfinder/Directions.vue'
import Map from './views/roomfinder/Map.vue'
import RoomFrom from './views/roomfinder/RoomFrom.vue'
import Download from './views/Download.vue'
import Logout from './views/Logout.vue'
import Notifications from './views/Notifications.vue'
import Settings from './views/Settings.vue'
import VotingRedirect from './views/voting/Redirect.vue'
import VotingLogin from './views/voting/VLogin.vue'
import VotingCollege from './views/voting/College.vue'
import VotingSchool from './views/voting/School.vue'
import VotingElection from './views/voting/Election.vue'
import VotingBallotBox from './views/voting/BallotBox.vue'
import VotingConfirmation from './views/voting/Confirmation.vue'
import BookingSearchDetails from './views/booking/SearchDetails.vue'
import BookingConfirmation from './views/booking/BookingConfirmation.vue'
import BookingResults from './views/booking/Results.vue'
import BookingSummary from './views/booking/Summary.vue'
import SubmitFeedback from './views/feedback/Form.vue'
import FeedbackConfirmation from './views/feedback/FeedbackConfirmation.vue'
import Wellbeing from './views/wellbeing/Wellbeing.vue'
import SubmitIncident from './views/support/Incident.vue'
import SupportConfirmation from './views/support/Confirmation.vue'
import AF from './views/AF.vue'
import AssessmentDetails from './views/af/AssessmentDetails.vue'
import Events from './views/events/Events.vue'
import SingleEvent from './views/events/SingleEvent.vue'
import KeyDates from './views/dates/KeyDates.vue'
import Clubs from './views/clubs/Clubs.vue'
import SingleClub from './views/clubs/SingleClub.vue'
import FindASpace from './views/FindASpace.vue'
// import Redirect from './views/Redirect.vue'
import Maintenance from './views/Maintenance.vue'
import ClearCache from './views/ClearCache.vue'
import Library from './views/Library.vue'
// import $cookies from 'vue-cookies'
import * as lst from '@/components/localStorage.js'
// import axios from 'axios' // test
// TEST for new MSAD login
import AltLogin from '@/msad/AltLogin.vue'
import AltLanding from '@/msad/AltLanding.vue'
import AzureLogin from './views/AzureLogin.vue'


// eslint-disable-next-line no-unused-vars
let loggedIn = false

const checkAuthentication = (to, from, next) => {
  const loggedIn = lst.hasKey('authenticated')
  if (loggedIn) {
    console.log('but the app says we are still logged in')
    /* FIXME we still seem to be stuck on the login screen here */
    next()
  } else {
    //Clear all except any unexpired notices (true)
    lst.clearAll(true)
    lst.setValue('requestedView', to.fullPath)
    next('/login')
  }

  // end

  /* if ($cookies.isKey('authenticated')) {
    next()
  } else {
    $cookies.set('requestedView', to.fullPath, 0)
    next('/login')
  } */
}

const recordError = (to, from) => {
  const path = from.fullPath
  console.log(path + ' triggered maintenance screen :-(')
  let maintscreens = []
  if (lst.hasKey('maintscreens')) {
    maintscreens = lst.getValue('maintscreens')
  }
  const d = new Date()
  maintscreens.push({
    path: path,
    epochMs: d.getTime()
  })
  lst.setValue('maintscreens', maintscreens)
}

// Use this to lazy load views
// component: () => import(/* webpackChunkName: "index" */ './views/Index.vue')
const router = createRouter({
  //  mode: 'history',
  // we had a problem converting to hashless (used to give us a blank screen)
  // but it seems to work fine now when we do createApp and then myapp.use(myrouter)...
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'index',
      component: Landing,
      beforeEnter: checkAuthentication
    },
    // {
    //   path: '/redirect',
    //   name: 'redirect',
    //  component: Redirect
    // },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/library/:tab?',
      name: 'library',
      component: Library,
      props: true
    },
    // {
    //  path: '/xbooking', // old booking screen
    //  name: 'booking',
    //  component: Booking,
    //  beforeEnter: checkAuthentication
    // },
    {
      path: '/buildingfrom',
      name: 'buildingfrom',
      component: BuildingFrom
    },
    {
      path: '/buildingto',
      name: 'buildingto',
      component: BuildingTo
    },
    {
      path: '/directions',
      name: 'directions',
      component: Directions
    },
    {
      path: '/download',
      name: 'download',
      component: Download,
      beforeEnter: checkAuthentication
    },
    {
      path: '/goingtobuilding',
      redirect: '/map'
    },
    {
      path: '/goingtoroom',
      redirect: '/map'
    },
    {
      path: '/map',
      name: 'map',
      component: Map
    },
    {
      path: '/nearme',
      redirect: '/map'
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications,
      beforeEnter: checkAuthentication
    },
    {
      path: '/roomfrom',
      name: 'roomfrom',
      component: RoomFrom
    },
    {
      path: '/roomto',
      redirect: '/map'
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      beforeEnter: checkAuthentication
    },
    {
      path: '/timetable',
      name: 'timetable',
      component: Timetable,
      beforeEnter: checkAuthentication
    },
    {
      path: '/menu',
      name: 'menu',
      component: Menu
    },
    {
      path: '/youarehere',
      redirect: '/map'
    },
    {
      path: '/voting/',
      name: 'votingRedirect',
      component: VotingRedirect,
      beforeEnter: checkAuthentication
    },
    {
      path: '/voting/login/:skip?',
      name: 'votingLogin',
      component: VotingLogin,
      beforeEnter: checkAuthentication
    },
    {
      path: '/voting/college',
      name: 'votingCollege',
      component: VotingCollege,
      beforeEnter: checkAuthentication
    },
    {
      path: '/voting/school',
      name: 'votingSchool',
      component: VotingSchool,
      beforeEnter: checkAuthentication
    },
    {
      path: '/voting/election',
      name: 'votingElection',
      component: VotingElection,
      beforeEnter: checkAuthentication
    },
    {
      path: '/voting/ballotbox',
      name: 'votingBallotBox',
      component: VotingBallotBox,
      beforeEnter: checkAuthentication
    },
    {
      path: '/voting/confirmation',
      name: 'votingConfirmation',
      component: VotingConfirmation,
      beforeEnter: checkAuthentication
    },
    {
      path: '/booking/',
      name: 'bookingSearchDetails',
      component: BookingSearchDetails,
      beforeEnter: checkAuthentication
    },

    {
      path: '/booking/confirm',
      name: 'bookingConfirmation',
      component: BookingConfirmation,
      beforeEnter: checkAuthentication
    },
    {
      path: '/booking/results/:location/:bookingDate/:startTime/:endTime/:attendees',
      name: 'bookingResults',
      component: BookingResults,
      beforeEnter: checkAuthentication,
      props: true
    },
    {
      path: '/booking/summary',
      name: 'bookingSummary',
      component: BookingSummary,
      beforeEnter: checkAuthentication,
      props: false
    },
    {
      path: '/feedback/',
      name: 'submitFeedback',
      component: SubmitFeedback,
      beforeEnter: checkAuthentication
    },
    {
      path: '/feedback/confirmation',
      name: 'feedbackConfirmation',
      component: FeedbackConfirmation,
      beforeEnter: checkAuthentication,
      props: true
    },
    {
      path: '/wellbeing/main',
      name: 'wellbeing',
      component: Wellbeing,
      beforeEnter: checkAuthentication
    },
    {
      path: '/support/incident',
      name: 'submitIncident',
      component: SubmitIncident,
      beforeEnter: checkAuthentication
    },
    {
      path: '/support/confirmation/:incidentNumber',
      name: 'supportConfirmation',
      component: SupportConfirmation,
      props: true
    },
    {
      path: '/deadlines/:tab?',
      name: 'Deadlines',
      component: AF,
      beforeEnter: checkAuthentication,
      props: true
    },
    {
      path: '/assessment/details/:id',
      name: 'assessmentDetails',
      component: AssessmentDetails,
      beforeEnter: checkAuthentication,
      props: true
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
      beforeEnter: checkAuthentication
    },
    {
      path: '/events/event',
      name: 'singleEvent',
      component: SingleEvent,
      beforeEnter: checkAuthentication,
      props: true
    },
    {
      path: '/keydates',
      name: 'keyDates',
      component: KeyDates
    },
    {
      path: '/clubs',
      name: 'clubs',
      component: Clubs,
      beforeEnter: checkAuthentication
    },
    {
      path: '/clubs/club',
      name: 'singleClub',
      component: SingleClub,
      beforeEnter: checkAuthentication,
      props: true
    },
    {
      path: '/findaspace/:tab?',
      name: 'findaspace',
      component: FindASpace,
      beforeEnter: checkAuthentication,
      props: true
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: Maintenance,
      beforeEnter: recordError,
      props: true
    },
    {
      path: '/clearcache',
      name: 'clearcache',
      component: ClearCache
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/adlogin', /* deprecated */
      name: 'adlogin',
      component: AltLogin
    },
    {
      path: '/adlanding', /* deprecated */
      name: 'adlanding',
      component: AltLanding
    },
    {
      path: '/azurelogin',
      name: 'azurelogin',
      component: AzureLogin
    },
    {
      path: '/code=:msCode(.*?)',
      component: AzureLogin
    },

    // ,
    //{
    /* need this extra route if we use createWebHistory
         i.e. if we don't want the hash in our URLs */
    /* 08/12/2023 problem with this is when you navigate to a new page it replaces the url
      e.g. /timetable on test changes the url to gla.ac.uk/timetable
           when it should be gla.ac.uk/t4/uofglife/test/timetable :-/ (*/
    //   path: '/:pathMatch(.*)*',
    //   name: 'not-found',
    //   component: Login
    //}
  ]
})

export default router
